// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__31kDE","file":"styles_file__whMAN"};